import type { DashboardFilter } from '@/types';

export type SelectionMode = 'select' | 'autocomplete' | 'multi_select';

/** Convert the default's wire encoding with the picker, never discard choices. */
export function changeSelectionMode(
  filter: DashboardFilter,
  type: SelectionMode,
): Partial<DashboardFilter> {
  let value = filter.default_value;
  if (filter.type === type) return { type };
  if (type === 'multi_select' && filter.type !== 'multi_select') {
    if (value) value = JSON.stringify([value]);
  } else if (filter.type === 'multi_select' && value) {
    const selected: unknown = JSON.parse(value);
    if (!Array.isArray(selected) || selected.length > 1 || selected.some(v => typeof v !== 'string')) {
      throw new Error('A single-select default must contain at most one value.');
    }
    value = selected[0] ?? '';
  }
  return { type, default_value: value };
}
